module.exports = __webpack_public_path__ + "img/hk.679d5ec3.svg";